/**
 * Internal dependencies
 */
import AnimateManager from './animate-manager';
import BlockArchiveManager from './block-archive-manager';
import BlockBeforeAfterManager from './block-before-after-manager';
import BlockImageVideoManager from './block-image-video-manager';
import BlockMenuManager from './block-menu-manager';
import BlockOpenerManager from './block-opener-manager';
import BlockPopinManager from './block-popin-manager';
import BlockSearchManager from './block-search-manager';
import BlockSliderManager from './block-slider-manager';
import BlockSwitchLang from './block-switch-lang';
import BlockTabManager from './block-tab-manager';
import FieldRadioManager from './field-radio-manager';
import PositionManager from './position-manager';
import ViewportManager from './viewport-manager';

/**
 * @note L'objet wmuwpb est initialisé dans /includes/front/scripts.php
 * @todo Réorganiser tout ça
 */

let styleElement = null;
let layoutElement = null;
let layoutWidth = null;

const animateManager = new AnimateManager();
const blockArchiveManager = new BlockArchiveManager();
const blockBeforeAfterManager = new BlockBeforeAfterManager();
const blockImageVideoManager = new BlockImageVideoManager();
const blockMenuManager = new BlockMenuManager();
const blockOpenerManager = new BlockOpenerManager();
const blockPopinManager = new BlockPopinManager();
const blockSearchManager = new BlockSearchManager();
const blockSliderManager = new BlockSliderManager();
const blockSwitchLang = new BlockSwitchLang();
const blockTabManager = new BlockTabManager();
const fieldRadioManager = new FieldRadioManager();
const positionManager = new PositionManager();
const viewportManager = ViewportManager;

/**
 * @todo Ajouter la gestion des radio-box avec toggleClass. On déplacera ça à terme quand on aura le temps
 * de réorganiser correctement les scripts et de mettre WMUToggle disponible à tout le monde hors import.
 */

export {
	animateManager,
	blockArchiveManager,
	blockBeforeAfterManager,
	blockImageVideoManager,
	blockMenuManager,
	blockOpenerManager,
	blockPopinManager,
	blockSearchManager,
	blockSliderManager,
	blockSwitchLang,
	blockTabManager,
	fieldRadioManager,
	positionManager,
	viewportManager,
};

/**
 * 
 */
const getLayoutElement = () =>
{
	if ( null === layoutElement && wmuwpb.layoutSelector )
	{
		if ( wmuwpb.layoutSelector )
		{
			layoutElement = document.querySelector( wmuwpb.layoutSelector );
		}

		if ( ! layoutElement )
		{
			layoutElement = document.querySelector( '#content' );
		}

		if ( ! layoutElement )
		{
			layoutElement = document.querySelector( 'body' );
		}
	}

	return layoutElement;
}

/**
 * 
 */
const getStyleElement = () =>
{
	if ( null === styleElement )
	{
		styleElement = document.createElement( 'style' );
		styleElement.setAttribute( 'type', 'text/css' );
		document.querySelector( 'head' ).appendChild( styleElement );
	}

	return styleElement;
}

/**
 * 
 */
const updateLayoutWidth = () =>
{
	let layoutEl = getLayoutElement();

	if ( layoutEl && layoutEl.clientWidth !== layoutWidth )
	{
		let styleEl = getStyleElement();

		if ( styleEl )
		{
			layoutWidth = layoutEl.clientWidth;
			styleEl.innerHTML = 'body { --wmu-layout-width: ' + layoutWidth + 'px; }';
		}
	}
}

/**
 * @todo Prendre en charge la valeur potentielle existante de style hors de notre système relatif au viewport.
 */
const updateBlocksStyle = ( contextElement = null ) =>
{
	const viewportCurrent = ViewportManager.viewportCurrent.toLowerCase();
	const viewportPrevious = ViewportManager.viewportPrevious.toLowerCase();

	if ( null === contextElement )
	{
		contextElement = document;
	}

	/**
	 * Switch {viewportCurrent}-style attribute to style attribute.
	 */
	[].forEach.call( contextElement.querySelectorAll( `[${viewportCurrent}-style]` ), ( element ) =>
	{
		element.setAttribute( 'style', element.getAttribute( `${viewportCurrent}-style` ) );
	} );

	/**
	 * Remove style attribute for elements which not have custom style in the current viewport.
	 */
	if ( viewportPrevious )
	{
		[].forEach.call( contextElement.querySelectorAll( `[${viewportPrevious}-style]:not([${viewportCurrent}-style])` ), ( element ) =>
		{
			element.removeAttribute( 'style' );
		} );
	}
};

/**
 * 
 */
const updateNewWindowLinks = ( contextElement = null ) =>
{
	if ( null === contextElement )
	{
		contextElement = document;
	}

	const viewportCurrent = ViewportManager.viewportCurrent;
	const viewportPrevious = ViewportManager.viewportPrevious;
	const previousLinks = ( viewportPrevious ) ? contextElement.querySelectorAll( `a.${viewportPrevious}-new-window` ) : [];
	const currentLinks = contextElement.querySelectorAll( `a.${viewportCurrent}-new-window` );

	/**
	 * Pour le moment on va retirer tous les events existants sur les previous links. Idéalement faudrait comparer
	 * avec les courants pour éviter de traiter ceux qui sont dans les 2. Pas le temps tout de suite.
	 */
	previousLinks.forEach( ( element ) =>
	{
		if ( element.wmuOpenNewWindow )
		{
			element.removeEventListener( 'click', element.wmuOpenNewWindow );
			element.wmuOpenNewWindow = undefined;
		}
	} );

	currentLinks.forEach( ( element ) =>
	{
		element.addEventListener( 'click', openNewWindow );
		element.wmuOpenNewWindow = openNewWindow;
	} );
};

/**
 * 
 * @param {Event} element 
 */
const openNewWindow = ( event ) =>
{
	const target = event.currentTarget;
	event.preventDefault();
	window.open( target.getAttribute( 'href' ) );
	return false;
};

/**
 * 
 */
const initGlobalBlockLink = ( contextElement = null ) =>
{
	if ( null === contextElement )
	{
		contextElement = document;
	}

	[].forEach.call( contextElement.querySelectorAll( '.block-global-link' ), ( element ) =>
	{
		const blockElement = element.closest( '.wmu-block' );
		const href = element.getAttribute( 'href' );

		if ( blockElement && href )
		{
			blockElement.classList.add( 'has-global-link' );
			blockElement.addEventListener( 'click', ( event ) =>
			{
				window.location = href;
			} );
		}
	} );
};

/**
 * 
 */
document.addEventListener( 'DOMContentLoaded', ( event ) =>
{
	ViewportManager.check();
	initGlobalBlockLink();
	updateLayoutWidth();

	// blockSearchManager.setup();

	/**
	 * 
	 */
	window.addEventListener( 'resize', ( event ) =>
	{
		ViewportManager.check();
		updateLayoutWidth();
	} );
} );

/**
 * 
 */
document.addEventListener( 'WMUViewportChange', ( event ) =>
{
	updateBlocksStyle();
	updateNewWindowLinks();
} );

/**
 * 
 */
window.addEventListener( 'wmuwpblocks/archive/itemsAdded', ( event ) =>
{
	if ( event.detail && event.detail.item && event.detail.item.length )
	{
		event.detail.item.forEach( ( item ) =>
		{	
			initGlobalBlockLink( item );
			updateNewWindowLinks( item );
			updateBlocksStyle( item );
		} );
	}
} );

/**
 * 
 * @todo Retirer tous les traitements sur wmuwpblocks/archive/itemsAdded et faire en sorte de passer
 * par l'event ci-dessous
 */
window.addEventListener( 'wmu/newElements', ( event ) =>
{
	if ( event.detail && event.detail.elements && event.detail.elements.length )
	{
		event.detail.elements.forEach( ( element ) =>
		{	
			initGlobalBlockLink( element );
			updateNewWindowLinks( element );
			updateBlocksStyle( element );

			blockArchiveManager.setup( element );
			blockTabManager.setup( element );
			blockSliderManager.setup( element );
		} );
	}
} );

/**
 * Test pour le dispatch event de recherche
 */
// window.addEventListener( 'wmuwpblocks/search/start', ( event ) =>
// {
// 	console.log( 'wmuwpblocks/search/start', event );
// } );

// window.addEventListener( 'wmuwpblocks/search/clickOnResultItem', ( event ) =>
// {
// 	console.log( 'wmuwpblocks/search/clickOnResultItem', event );
// } );